import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import cn from "./cn.json";

/**
 * v0.4.5 / I1+I4 — i18next scaffold.
 *
 * EN is authoritative. CN is loaded but only switchable once its
 * `_meta.review_status` flips to "REVIEWED" (per spec amendment 1).
 * Until then the language switcher chip in the Header is hidden.
 *
 * Supported locales:
 *   - en : REVIEWED
 *   - cn : REVIEWED  ← signed off 2026-06-22 (v0.5.0i+1)
 */

const RESOURCES = { en, cn };
export const ALL_LOCALES = ["en", "cn"];

export const reviewStatus = (locale) =>
  RESOURCES[locale]?._meta?.review_status || "UNKNOWN";

export const switchableLocales = () =>
  ALL_LOCALES.filter((l) => reviewStatus(l) === "REVIEWED");

const stored = (() => {
  try {
    return localStorage.getItem("gd_vat_locale");
  } catch {
    return null;
  }
})();

const initialLocale =
  stored && switchableLocales().includes(stored) ? stored : "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      cn: { translation: cn },
    },
    lng: initialLocale,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false },
  });

export default i18n;
